import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-red.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6fe0346a")

_pushScopeId("data-v-6fe0346a")
const _hoisted_1 = { class: "text-gray-lp-600 text-wrapper" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: `w-4`,
  alt: "up"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  class: `w-4`,
  alt: "down"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_card = _resolveComponent("card")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock(_component_DataWrapper, {
    label: "Kategori Barang",
    class: "w-full mr-4 mt-2",
    fontSize: 14
  }, {
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.goodsNames, (item, index) => {
        return (_openBlock(), _createBlock(_Fragment, { key: index }, [
          (_ctx.isExpanded ? true : index < 3)
            ? (_openBlock(), _createBlock(_component_card, {
                key: 0,
                class: "p-4 mt-2 bg-gray-lp-1500",
                isShadow: false
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, _toDisplayString(_ctx.wrapText(item)), 1)
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      (_ctx.goodsNames.length > 3)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "flex flex-row py-4 gap-1 items-center cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setExpand && _ctx.setExpand(...args)))
          }, [
            _createVNode(_component_lp_button, {
              title: _ctx.expandedTitle,
              flat: true,
              compact: true,
              textColor: "red-lp-300"
            }, null, 8, ["title"]),
            (_ctx.isExpanded)
              ? (_openBlock(), _createBlock("img", _hoisted_2))
              : (_openBlock(), _createBlock("img", _hoisted_3))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})